import { render } from 'preact';
import { AuthBrandingColumn } from '../components/auth/AuthBrandingColumn.jsx';
import { AuthLoginPanel } from '../components/auth/AuthLoginPanel.jsx';
import { initAuthPasswordToggles } from '../lib/auth-password-toggle.js';
import { initRegisterGoogleAuth } from '../lib/auth-google-register.js';
import '../styles/landing.css';
import '../styles/auth-portal.css';

function readBootstrap() {
  const el = document.getElementById('auth-portal-bootstrap');
  if (!el?.textContent) return {};
  try {
    return JSON.parse(el.textContent);
  } catch {
    return {};
  }
}

function readPageDataset() {
  const el = document.getElementById('auth-portal-page');
  if (!el) {
    return { favicon: '/static/img/favicon.ico', heroBg: '/media/landingpage/sluet3.png', mode: 'login' };
  }
  return {
    favicon: (el.dataset.favicon || '/static/img/favicon.ico').trim(),
    heroBg: (el.dataset.heroBg || '/media/landingpage/sluet3.png').trim(),
    mode: (el.dataset.mode || 'login').trim(),
  };
}

const page = readPageDataset();
const bootstrap = readBootstrap();
document.documentElement.style.setProperty('--pp-auth-hero-bg', `url("${page.heroBg}")`);

const brandingRoot = document.getElementById('auth-portal-branding');
async function mountBranding() {
  if (!brandingRoot) return;
  let registrationCredits = 0;
  try {
    const res = await fetch('/api/gifts/');
    if (res.ok) {
      const data = await res.json();
      registrationCredits = Number(data?.registration?.default) || 0;
    }
  } catch {
    registrationCredits = 0;
  }
  render(
    <AuthBrandingColumn
      favicon={page.favicon}
      registerUrl={page.mode === 'login' ? bootstrap.registerUrl || '/accounts/register/' : null}
      registrationCredits={registrationCredits}
    />,
    brandingRoot,
  );
}
mountBranding();

const loginRoot = document.getElementById('auth-portal-login-root');
if (loginRoot && page.mode === 'login') {
  render(<AuthLoginPanel config={bootstrap} />, loginRoot);
}

if (page.mode === 'register') {
  const runRegisterExtras = () => {
    initAuthPasswordToggles();
    initRegisterGoogleAuth();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runRegisterExtras);
  } else {
    runRegisterExtras();
  }
}
